import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
	(
		<Suspense fallback={<SuspenseLoader />}>
			<Component {...props} />
		</Suspense>
	);

const List = Loader(lazy(() => import('src/content/areas/List')));
const Create = Loader(lazy(() => import('src/content/areas/Create')));

const areasRoutes = [
	{
		path: '',
		element: <Navigate to="list" replace />
	},
	{
		path: 'list',
		element: <List />
	},
	{
		path: 'list/create',
		element: <Create />
	},
	{
		path: 'list/edit/:id',
		element: <Create />
	}
];

export default areasRoutes;
